import {PayrollPack, PayrollPackRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {TableCell, Typography} from "@mui/material";
import {payrollPeriod} from "../payroll";
import {useApiManager} from "../../../../components/utils/api";
import {CustomNumberFormat} from "../../../../components/utils/custom_number_format";

/** Tipos de pack: el enum del API llega en clave («PLA», el formato que lee PlaPayrollProcessor). */
export const PAYROLL_PACK_TYPE_LABELS: Record<string, string> = {
	PLA: "Formato PLA",
	OTHER: "Otro",
};

export const PayrollPackListPage = () => {
	const apiManager = useApiManager();

	const listConfig: AppListConfig<PayrollPack> = {
		title: "Packs de nóminas",
		onClick: "/app/admin/employee/payrollpack",
		headers: [
			{title: "Período"},
			{title: "Tipo"},
			{title: "Coste empresa", align: "right"}
		],
		decorator: (bean: PayrollPack) => (
			< >
				<TableCell>
					<Typography variant="body2" fontWeight={600}>{payrollPeriod(bean.periodFrom, bean.periodTo)}</Typography>
				</TableCell>
				<TableCell>
					{PAYROLL_PACK_TYPE_LABELS[bean.type || ""] || bean.type}
				</TableCell>
				<TableCell align={"right"} sx={{fontVariantNumeric: "tabular-nums"}}>
					<CustomNumberFormat amount={bean.companyCost}/>
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {

			const ctrl = apiManager.factory(PayrollPackRestControllerApiFactory);
			return ctrl.pagePayrollPack(currentPage, size, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};